const sortObject = (obj, sortBy) => {
  let sortedObj = obj.sort(
    (a, b) => parseFloat(a[sortBy]) - parseFloat(b[sortBy])
  );
  return sortedObj;
};

export default sortObject;
